import { Button } from "@ziolo/ui";

const CALLS = [
  {
    name: "Voisins du zéro",
    cover: "17 numerów wokół zera · 9 żetonów",
    numbers: "22, 18, 29, 7, 28, 12, 35, 3, 26, 0, 32, 15, 19, 4, 21, 2, 25",
    detail: "Trio 0-2-3 (2), splity 4/7, 12/15, 18/21, 19/22, 32/35, narożnik 25-26-28-29 (2).",
  },
  {
    name: "Jeu zéro",
    cover: "7 numerów przy zerze · 4 żetony",
    numbers: "0, 3, 12, 15, 26, 32, 35",
    detail: "Splity 0/3, 12/15, 32/35 i numer 26.",
  },
  {
    name: "Tiers du cylindre",
    cover: "12 numerów naprzeciw zera · 6 żetonów",
    numbers: "27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33",
    detail: "Splity 5/8, 10/11, 13/16, 23/24, 27/30, 33/36.",
  },
  {
    name: "Orphelins",
    cover: "8 sierot · 5 żetonów",
    numbers: "1, 20, 14, 31, 9, 17, 34, 6",
    detail: "Numer 1 oraz splity 6/9, 14/17, 17/20, 31/34.",
  },
] as const;

const STANDARD = [
  { name: "Numer", payout: "35:1", detail: "Pojedyncze pole 0–36." },
  { name: "Split", payout: "17:1", detail: "Linia między dwoma sąsiadami." },
  { name: "Street", payout: "11:1", detail: "Trzy numery w jednej kolumnie (np. 1-2-3)." },
  { name: "Trio", payout: "11:1", detail: "0-1-2 albo 0-2-3, przy zerze." },
  { name: "Corner", payout: "8:1", detail: "Kwadrat czterech numerów." },
  { name: "Linia", payout: "5:1", detail: "Dwa sąsiednie street’y (6 numerów)." },
  { name: "Tuzin / kolumna", payout: "2:1", detail: "1–12, 13–24, 25–36 albo 2:1 z prawej." },
  { name: "Kolor, parzyste, 1–18", payout: "1:1", detail: "Równe szanse; zero przegrywa." },
  { name: "Sąsiedzi ±2", payout: "35:1", detail: "Na torze: wybrany numer i dwa z każdej strony koła." },
] as const;

export function RuletkaHelp({ onClose }: { onClose: () => void }) {
  return (
    <div
      className="rl-help-root"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="rl-help" role="dialog" aria-labelledby="rl-help-title">
        <div className="rl-help__head">
          <h2 id="rl-help-title">Jak stawiać</h2>
          <Button size="sm" onClick={onClose}>
            Zamknij
          </Button>
        </div>
        <p className="rl-help__lead">
          Klik na polu kładzie wybrany nominał. Split, street, narożnik i linia są na krawędziach sukna — złoty
          podświetlacz pokazuje, co stawiasz. Na torze włącz „Sąsiedzi ±2”, żeby obstawić pięć numerów wokół klikniętego.
        </p>
        <section>
          <h3>Zakłady francuskie</h3>
          <ul className="rl-help__list">
            {CALLS.map((item) => (
              <li key={item.name}>
                <strong>{item.name}</strong>
                <span>{item.cover}</span>
                <span className="rl-help__nums">{item.numbers}</span>
                <small>{item.detail}</small>
              </li>
            ))}
          </ul>
        </section>
        <section>
          <h3>Sukno</h3>
          <ul className="rl-help__grid">
            {STANDARD.map((item) => (
              <li key={item.name}>
                <span>
                  {item.name} <em>{item.payout}</em>
                </span>
                <small>{item.detail}</small>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}
